import React from "react";

import { Card } from "../card";
import { GridWrapper } from "../GridWrapper/GridWrapper";
import { AddResult } from "./AddResult";
import { ListResults } from "./ResultList";

export const ResultsComponent = () => {
  return (
    <GridWrapper
      totalColumns={3}
      childrens={[
        {
          component: (
            <Card wrapperStyle={{ height: "100%" }} cardTitle="Add result">
              <div>
                <AddResult />
              </div>
            </Card>
          ),
          gridSpan: 1,
        },
        {
          component: (
            <Card wrapperStyle={{ height: "100%" }} cardTitle="All results">
              <div>
                <ListResults />
              </div>
            </Card>
          ),
          gridSpan: 2,
        },
      ]}
    />
  );
};
